import fetch from "auth/FetchInterceptor";

const authService = {};

authService.post = async function (data) {
	return fetch({
		url: "/v1/rest/auth",
		method: "post",
		data: data,
		headers: {
			"public-request": "true",
		},
	});
};

authService.verifyEmail = async function (email) {
	return fetch({
		url: "/v1/rest/auth/verify-email?email=" + email,
		method: "get",
		headers: {
			"public-request": "true",
		},
	});
};

authService.sendMailToResetPwd = async function (email) {
	return fetch({
		url: "/v1/rest/auth/send-mail-reset-pwd",
		method: "post",
		data: {
			email: email,
		},
		headers: {
			"public-request": "true",
		},
	});
};

export default authService;
